import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import AuthGuard from './AuthGuard'
import { UserContext } from '../context/userContext'
import { ADJUDICATION_AUDIT_USER_ID } from '../utils/constants'

// A diferencia de AdminGuard (que filtra por rol), esta ruta es visible para un
// único usuario puntual, así que se compara directo contra su externalId en vez
// de pasar por el mapa de roles/permisos.
function SingleUserCheck({ children }) {
  const { userData } = useContext(UserContext)

  if (userData?.externalId !== ADJUDICATION_AUDIT_USER_ID) {
    return <Redirect to="/auctionList" />
  }
  return children
}

export default function AdjudicationAuditGuard({ children }) {
  return (
    <AuthGuard>
      <SingleUserCheck>{children}</SingleUserCheck>
    </AuthGuard>
  )
}
